import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { get } from 'lodash';

import { AppDispatch, IStore } from '../../../../store.type';
import { PersonalInfoContainer, PersonalInfoHeading } from '../styles';
import { fieldsRenderer } from '@Utils/document-upload/document-upload';
import { FORMNAME_RFI, SG } from '@Utils/constants';
import { CommonButton } from '@Components';
import { getSgkycFlowRfiData } from '@Redux/selectors';
import { SG_ODD_FLOW_TYPES } from '../ScreenConstants';
import { setFlowType } from '@Redux/actions/rfi/rfi-action';
import { DocumentOption, NestedField } from '../types';
import { changeFormField, PERSONAL_INFO_PAGE } from '../utils';

export const PersonalInfoPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const sgKycFlowData = useSelector(getSgkycFlowRfiData);
  const renderingObject = sgKycFlowData?.renderingObject;
  const getAllformVal = useSelector((state: IStore) => getFormValues(FORMNAME_RFI)(state) || {});
  const radioFieldName = sgKycFlowData?.rfiDetails?.fields_json?.[0]?.field_name || '';
  const isPermanentSGResident = get(
    getAllformVal,
    radioFieldName?.replace(/\.[^.]+$/, '.is_permanent_sg_resident'),
    false
  );
  const nationality = String(
    get(getAllformVal, radioFieldName?.replace(/\.[^.]+$/, '.nationality'), '')
  );
  const allRenderringFields =
    renderingObject?.values?.filter((item: DocumentOption) => item.code === 'MANUAL')?.[0]
      ?.nested_fields_json || [];
  const [renderingFields, setRenderingFields] = useState(allRenderringFields);
  const { heading, buttonText } = PERSONAL_INFO_PAGE;

  useEffect(() => {
    if (!nationality || nationality === SG) {
      setRenderingFields(
        allRenderringFields?.filter(
          (item: NestedField) => item.name !== 'is_permanent_sg_resident'
        ) || []
      );
    } else if (nationality !== SG) {
      setRenderingFields(allRenderringFields || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllformVal]);

  const handleSaveAndContinue = () => {
    if (nationality === SG) {
      dispatch(setFlowType(SG_ODD_FLOW_TYPES.NRIC));
      changeFormField(radioFieldName, 'flow_type', SG_ODD_FLOW_TYPES.NRIC, dispatch);
      changeFormField(radioFieldName, 'is_permanent_sg_resident', true, dispatch);
    } else if (nationality !== SG) {
      dispatch(
        setFlowType(isPermanentSGResident ? SG_ODD_FLOW_TYPES.NRIC_PR : SG_ODD_FLOW_TYPES.FIN)
      );
      changeFormField(
        radioFieldName,
        'flow_type',
        isPermanentSGResident ? SG_ODD_FLOW_TYPES.NRIC_PR : SG_ODD_FLOW_TYPES.FIN,
        dispatch
      );
    }
    //Event propagation to main rfi file submitRfi function
  };

  return (
    <PersonalInfoContainer>
      <PersonalInfoHeading>{heading}</PersonalInfoHeading>
      {fieldsRenderer(
        renderingFields || [],
        false,
        getAllformVal,
        {
          dispatch,
          change,
          FORMNAME_RFI
        },
        null,
        true
      )}
      <div className="submitBtnContainer">
        <CommonButton text={buttonText} width="250px" onClick={handleSaveAndContinue} />
      </div>
    </PersonalInfoContainer>
  );
};
